export default "__VITE_ASSET__B7Wa3AuV__"